import { type ReactNode, useState } from 'react';

import cn from 'classnames';

import { VideoPlayButton } from 'ui/atoms/VideoPlayButton/VideoPlayButton';

import styles from './VideoOverview.module.scss';

type Props = {
  videoId: string;
  className?: string;
  title?: ReactNode;
  description?: ReactNode;
};

const baseClass = 'video-overview';

export const VideoOverview = ({ videoId, className, title, description }: Props) => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <section className={cn(styles[`${baseClass}-wrapper`], className)} id="video-presentation">
      <div className={styles[`${baseClass}-container`]}>
        <div className={styles[`${baseClass}-title`]}>
          <h2>{title || 'See How Verified Data Works in Action'}</h2>

          <p>
            {description ||
              'Discover how our first-party platform ensures every insight is backed by verified registry data. This short demo shows you how it all works.'}
          </p>
        </div>

        <div className={styles[`${baseClass}-video`]}>
          {!isPlaying ? (
            <div className={styles[`${baseClass}-preview`]}>
              <VideoPlayButton onClick={() => setIsPlaying(true)} />
            </div>
          ) : (
            <iframe
              frameBorder="0"
              title="Video presentation"
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </div>
    </section>
  );
};
